import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Helmet } from 'react-helmet-async';

const EventBids = () => {
    const eventTitle = process.env.REACT_APP_EVENT_TITLE || 'EventSawa';
    const eventDescription = process.env.REACT_APP_EVENT_DESCRIPTION || 'We make events sawa';
    const { eventId } = useParams();
    const [event, setEvent] = useState(null);
    const [bids, setBids] = useState([]);
    const [price, setPrice] = useState("");
    const [description, setDescription] = useState("");

    useEffect(() => {
        axios.get(`/api/events/${eventId}/`).then((res) => setEvent(res.data));
        axios.get(`/api/events/${eventId}/bids/`).then((res) => setBids(res.data));
    }, [eventId]);

    const submitBid = () => {
        axios.post(`/api/events/${eventId}/create-bid/`, { price, description })
            .then((res) => setBids([...bids, res.data]));
    };

    if (!event) return <p>Loading event...</p>;

    return (
        <div>
            <Helmet>
                <title>{eventTitle}</title> {/* Set page title from environment variable */}
                <meta name="description" content={eventDescription} />
            </Helmet>
            <h2>{event.title}</h2>
            <p>{event.description}</p>
            <p><strong>Location:</strong> {event.location}</p>
            <p><strong>Date:</strong> {event.date} - {event.time}</p>

            <h3>Bids</h3>
            {bids.length === 0 ? <p>No bids yet</p> : bids.map((bid) => (
                <div key={bid.id} style={{ border: "1px solid #ddd", padding: "8px", marginBottom: "8px" }}>
                    <p><strong>Provider:</strong> {bid.provider}</p>
                    <p><strong>Price:</strong> ${bid.price}</p>
                    <p>{bid.description}</p>
                    <p>Status: {bid.status}</p>
                </div>
            ))}

            <h3>Place a Bid</h3>
            <input type="text" placeholder="Price" value={price} onChange={(e) => setPrice(e.target.value)} />
            <textarea placeholder="Description" value={description} onChange={(e) => setDescription(e.target.value)} />
            <button onClick={submitBid}>Submit Bid</button>
        </div>
    );
};

export default EventBids;
